import { render, staticRenderFns } from "./IconLinkedin.vue?vue&type=template&id=6de8f838&scoped=true&"
var script = {}
import style0 from "./IconLinkedin.vue?vue&type=style&index=0&id=6de8f838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8f838",
  null
  
)

export default component.exports